import { axiosInstance } from "@/lib/axios"

export interface EmailTemplate {
  _id: string
  slug: 'update' | 'fixed' | 'new-feature' | 'info'
  name: string
  subject: string
  title: string
  content: string
  imageUrl: string | null
  buttonText: string | null
  buttonUrl: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface SendEmailParams {
  to: string
  subject: string
  title?: string
  content: string
  imageUrl?: string
  buttonText?: string
  buttonUrl?: string
}

export interface BulkEmailRecipient {
  email: string
  username: string
  companyName: string
}

export interface BulkEmailResult {
  success: number
  failed: number
  errors: Array<{
    email: string
    error: string
  }>
}

class EmailService {
  // Tek email gönder
  async send(params: SendEmailParams) {
    return axiosInstance.post("/email/send", params)
  }

  // Şablon ile toplu email gönder
  async sendBulkWithTemplate(templateSlug: string, recipients: BulkEmailRecipient[]) {
    return axiosInstance.post<{ status: string; message: string; data: BulkEmailResult }>(
      "/email/send-bulk",
      {
        templateSlug,
        recipients
      }
    )
  }

  // Custom içerik ile toplu email gönder
  async sendBulkCustom(
    customTemplate: {
      subject: string
      title: string
      content: string
      imageUrl?: string
      buttonText?: string
      buttonUrl?: string
    },
    recipients: BulkEmailRecipient[]
  ) {
    return axiosInstance.post<{ status: string; message: string; data: BulkEmailResult }>(
      "/email/send-bulk",
      {
        customTemplate,
        recipients
      }
    )
  }

  // CDN'e resim yükle
  async uploadImage(file: File) {
    const formData = new FormData()
    formData.append('image', file)

    return axiosInstance.post<{
      status: string
      message: string
      data: {
        url: string
        fileName: string
        originalName: string
      }
    }>("/email/upload-image", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export const emailService = new EmailService()
